module.exports = __webpack_public_path__ + "img/bg-picture-3.63991be6.jpg";